import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store/state';
import { Subscription } from 'rxjs';
import { auditTime } from "rxjs/operators";

import { getHourlyPouchCountDevice } from 'src/app/store/selectors/pharmacy-peek.selector';
import { PouchCountChartData } from '../../../models/pouch-count-chart-data';
import { SignalEventType } from 'src/app/shared/signalr/models/signal-event-type';
import { PharmacyPeekActions } from 'src/app/store/actions';
import { addSignalRSubList, deleteSignalRSubList } from 'src/app/store/actions/signalr.action';
import { SignalRService } from 'src/app/shared/signalr/service/signal-r.service';
import { ToastPanelType } from 'src/app/config/app-constants';
import { LoggerService } from 'src/app/shared/services/logger.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ViewStoreService } from '../../../services/view-type.service';

@Component({
    selector: 'app-hourly-pouch-count-device',
    templateUrl: './hourly-pouch-count-device.component.html',
    styleUrls: ['./hourly-pouch-count-device.component.scss'],
    standalone: false
})
export class HourlyPouchCountDeviceComponent implements OnInit {

  @Input() systemConfig: any;

  avgHoursToday: number | string;
  avgHoursTodayHidden: number;
  totalToday: number | string;
  totalTodayHidden: number;
  hourCountHidden: [];
  pouchCountDataToday: PouchCountChartData[] = [];
  noDataExistsForHPC = true;
  deviceId: string;
  deviceName: string;
  todayDay = '';

  subscription!: Subscription;

  signalrSubList = {
    type: SignalEventType.HPC_DEVICE,
    deviceId: ''
  }

  constructor(
    public store: Store<State>,
    private signal: SignalRService,
    public toastService: ToastService,
    public viewStoreService: ViewStoreService,
    private loggerService: LoggerService,
  ) { }

  ngOnInit(): void {

    this.store.select(getHourlyPouchCountDevice).subscribe(res => {
      const resData: any = res;
      if (resData && resData.length > 0) {
        this.deviceId = this.systemConfig?.deviceId ? this.systemConfig?.deviceId : '';
        resData.forEach((element:any) => {
          if (this.deviceId === element.deviceId) {
            this.updateChartFromAPIData(element);
            this.noDataExistsForHPC = false;
          }
        });
      }
      else {
        this.noDataExistsForHPC = true;
      }
    });
    
    this.subscription = this.signal.getDataStream<string>(SignalEventType.HPC_DEVICE)
    .pipe(auditTime(1000))
    .subscribe(dataObj => {
      this.store.dispatch(PharmacyPeekActions.updateHourlyPouchCountDevice({ data: dataObj.data }));
    })

    this.signalrSubList = {
      type: SignalEventType.HPC_DEVICE,
      deviceId: this.systemConfig?.deviceId ? this.systemConfig?.deviceId : ''
    }

    this.callHPCDevice();
  }

  ngAfterViewInit() {
    this.store.dispatch(addSignalRSubList({ data: this.signalrSubList }));
    this.deviceId = this.systemConfig?.deviceId;
    this.deviceName = this.systemConfig?.deviceName;
  }

  ngOnDestroy() {
    this.store.dispatch(deleteSignalRSubList({ data: this.signalrSubList }));
    this.subscription.unsubscribe();
  }

  
  private callHPCDevice() {
   const deviceId = this.systemConfig?.deviceId ? this.systemConfig?.deviceId : '';
    this.viewStoreService.getHourlyPouchCount(deviceId).subscribe(
      (response) => {
        this.store.dispatch(PharmacyPeekActions.getHourlyPouchCountDevice({ data: response }));
      },
      (error) => {
        console.log('HourlyPouchCount Service error:', error);

        if (error.status === 404) {
          this.loggerService.logWarning('HourlyPouchCount  No data exists: ', error);
        } else {
          this.toastService.openToast('HourlyPouchCount service load error!', ToastPanelType.error);
        }
      },
    );
  }

  private updateChartFromAPIData(data) {
    this.pouchCountDataToday = [...Array(24)].map((v, i) => {
      const time = `${(i % 12) || 12}${i < 12 ? 'a' : 'p'}`;
      const count = (i >= 0) ? data.data.hourCounts[i] : 0;
      return {
        time,
        count,
        max: Math.ceil(Math.max(...data.data.hourCounts) / 100) * 100,
        tooltip: `<b>${count}</b>&nbsp;pouch${count >= 2 ? 'es' : ''} – ${i % 12 || 12} ${i < 12 ? 'AM' : 'PM'}`,
      };
    });

    const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const d = new Date();
    const day = weekday[d.getDay()];
    this.todayDay = day + ' Avg';
    this.avgHoursToday = this.kFormatter(data.data.average);
    this.avgHoursTodayHidden = data.data.average;
    this.totalToday = this.kFormatter(data.data.total);
    this.totalTodayHidden = data.data.total;
    this.hourCountHidden = data.data.hourCounts.toString();

    this.deviceId = this.systemConfig?.deviceId ? this.systemConfig?.deviceId : null;
    this.deviceName = this.systemConfig?.deviceName ? this.systemConfig?.deviceName : null;
  }

  kFormatter(num) {
    return Math.abs(num) > 999 ? Math.sign(num) * (Math.round(Math.abs(num) / 100) / 10) + 'k' : Math.sign(num) * Math.abs(num)
  }
}
